import {
  User,
  getAuth,
  signInWithEmailAndPassword as _signInWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
  FacebookAuthProvider,
  OAuthProvider,
  UserCredential, // Import UserCredential type
} from "firebase/auth";
// Import FIREBASE_APP instead of app, and also FIREBASE_AUTH and FIREBASE_WEB_CLIENT_ID
import { FIREBASE_APP, FIREBASE_AUTH } from "./config";

// Function to get the currently signed-in user
export const getCurrentUser = (): User | null => {
  const auth = getAuth(FIREBASE_APP);
  return auth.currentUser;
};

// No need to instantiate getAuth(app) here, use FIREBASE_AUTH from config directly
// const auth = getAuth(FIREBASE_APP); // This line is no longer necessary if you use FIREBASE_AUTH below

export const loginWithEmailAndPassword = (
  email: string,
  password: string,
): Promise<UserCredential> => {
  return _signInWithEmailAndPassword(FIREBASE_AUTH, email, password);
};

export const googleSignin = async (): Promise<UserCredential> => {
  const provider = new GoogleAuthProvider();
  // Optionally, if you needed to use the webClientId for specific provider config:
  // provider.setCustomParameters({ login_hint: 'user@example.com' }); // Example
  try {
    const result = await signInWithPopup(FIREBASE_AUTH, provider);
    return result;
  } catch (error: any) {
    console.error("Google Sign-In Error:", error);
    throw error;
  }
};

export const facebookSignIn = async (): Promise<UserCredential> => {
  const provider = new FacebookAuthProvider();
  try {
    const result = await signInWithPopup(FIREBASE_AUTH, provider);
    return result;
  } catch (error: any) {
    console.error("Facebook Sign-In Error:", error);
    throw error;
  }
};

export const signinWithApple = async (): Promise<UserCredential> => {
  const provider = new OAuthProvider("apple.com");
  try {
    const result = await signInWithPopup(FIREBASE_AUTH, provider);
    return result;
  } catch (error: any) {
    console.error("Apple Sign-In Error:", error);
    throw error;
  }
};

// You had a Redundant configuration for Google Sign-in in config.ts.
// It's removed from config.ts, but if you needed to use the webClientId,
// it would be relevant for your GoogleAuthProvider setup. For simplicity,
// we often just use the default set via the Firebase console.
